import { PlusOutlined } from '@ant-design/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { deleteListVehicle, getListVehicleFull, setSelectedRowKeys, setTypeModal, setValueSearch, updateSearch } from '../redux';
import { useDispatch, useSelector } from 'react-redux';
import { ActionType } from 'helper/constants';
import { selectedRowKeysSelector, valueSearchSelector } from '../selector';
import { useRolesByRouter } from 'helper/cusHooks';
import includes from 'lodash/includes';
import { actionsType } from 'components/layouts/redux/leftMenu';
import { RowHeader, TitleHeader, WrapperButton } from 'components/commons/Template/style';
import Button, { TypeCustom, TypeSizeCustom } from 'components/commons/Button';
import ModalConfirm from 'components/commons/modalConfirm';
import { useEffectOnce } from 'react-use';
import { CReloadButton } from 'components/commons/ReloadButton';
import CustomSearch from 'components/commons/Search';

function Header() {
  const dispatch = useDispatch();
  const selectedRowKeys = useSelector(selectedRowKeysSelector);
  const valueSearch = useSelector(valueSearchSelector);
  const listRole = useRolesByRouter();
  const intl = useIntl();

  const handleAddRole = () => {
    dispatch(setTypeModal(ActionType.ADD));
  };

  useEffectOnce(() => {
    dispatch(getListVehicleFull());
  });

  const handleDeleteMuti = () => {
    ModalConfirm({
      title: 'common.confirmDelete',
      message: 'common.relatedDataDeleted',
      handleConfirm: () => {
        dispatch(deleteListVehicle(selectedRowKeys as string[]));
        dispatch(setSelectedRowKeys([]));
      },
    });
  };

  const handleSearch = (values: string) => {
    dispatch(
      updateSearch({
        q: values,
        page: 0,
      })
    );
  };

  const handleRefresh = () => {
    dispatch(
      updateSearch({
        page: 0,
        size: 10,
        q: '',
      })
    );
    dispatch(setValueSearch(''));
  };

  const setValueQS = (value: string) => {
    dispatch(setValueSearch(value));
  };

  return (
    <>
      <TitleHeader>
        <FormattedMessage id="layout.leftMenu.vehicleManager" />
      </TitleHeader>
      <RowHeader>
        <WrapperButton>
          <CustomSearch
            tooltip={intl.formatMessage({ id: 'vehicleManagement.tooltipQS' })}
            onSearch={handleSearch}
            value={valueSearch}
            setValue={setValueQS}
          />
          <CReloadButton onClick={handleRefresh} />
        </WrapperButton>
        <WrapperButton>
          {includes(listRole, actionsType.DELETE) && (
            <Button
              sizeCustom={TypeSizeCustom.Medium}
              typeCustom={TypeCustom.Secondary}
              activeCustom={selectedRowKeys.length ? true : false}
              disabledCustom={selectedRowKeys.length ? false : true}
              onClick={handleDeleteMuti}
            >
              <FormattedMessage id="common.delete" />
            </Button>
          )}
          {includes(listRole, actionsType.CREATE) && (
            <Button sizeCustom={TypeSizeCustom.Medium} typeCustom={TypeCustom.Primary} icon={<PlusOutlined />} onClick={handleAddRole}>
              <FormattedMessage id="common.add" />
            </Button>
          )}
        </WrapperButton>
      </RowHeader>
    </>
  );
}

export default Header;
